import api from '../api'

let ws = null
const onMessageChannel = {}
const onOpenChannel = {}
const onCloseChannel = {}
const onErrorChannel = {}

// A hook to maintenance a single websocket instance
const useWebSocket = () => {
  const broadcast = (channel, e) => {
    const subscribers = Object.keys(channel)

    subscribers.forEach(s => {
      if (channel[s]) {
        channel[s](e)
      }
    })
  }

  const onSocketOpen = (e) => broadcast(onOpenChannel, e)
  const onSocketMessage = (e) => broadcast(onMessageChannel, JSON.parse(e.data))
  const onSocketClose = (e) => broadcast(onCloseChannel, e)
  const onSocketError = (e) => broadcast(onErrorChannel, e)

  const connectWebSocket = (roomKey, code) => {
    if (!ws) {
      ws = new WebSocket(api.ws.host(roomKey, code))
      ws.onopen = onSocketOpen
      ws.onmessage = onSocketMessage
      ws.onclose = onSocketClose
      ws.onerror = onSocketError
    }
  }

  const disconnectWebSocket = () => {
    if (ws) {
      ws.close()
      ws = null
    }
  }

  // on open
  const subscribeOnOpen = (name, fn) => onOpenChannel[name] = fn
  const unsubscribeOnOpen = (name) => delete onOpenChannel[name]

  // on message
  const subscribeOnMessage = (name, fn) => onMessageChannel[name] = fn
  const unsubscribeOnMessage = (name) => delete onMessageChannel[name]

  // on close
  const subscribeOnClose = (name, fn) => onCloseChannel[name] = fn
  const unsubscribeOnClose = (name) => delete onCloseChannel[name]

  // on error
  const subscribeOnError = (name, fn) => onErrorChannel[name] = fn
  const unsubscribeOnError = (name) => delete onErrorChannel[name]

  const sendWebsocketMessage = (message) => {
    if (ws) {
      ws.send(message)
    }
  }

  return {
    connectWebSocket,
    disconnectWebSocket,
    subscribeOnOpen,
    unsubscribeOnOpen,
    subscribeOnClose,
    unsubscribeOnClose,
    subscribeOnError,
    unsubscribeOnError,
    subscribeOnMessage,
    unsubscribeOnMessage,
    sendWebsocketMessage,
  }
}

export default useWebSocket